import { render, staticRenderFns } from "./InformePrograma.vue?vue&type=template&id=60fc3111&scoped=true&"
import script from "./InformePrograma.vue?vue&type=script&lang=js&"
export * from "./InformePrograma.vue?vue&type=script&lang=js&"
import style0 from "./InformePrograma.vue?vue&type=style&index=0&id=60fc3111&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fc3111",
  null
  
)

export default component.exports